<template>
  <page />
</template>

<script setup lang="ts">
  import { defineAsyncComponent } from 'vue';
  import { useAsyncData, useNuxtApp, useRoute } from 'nuxt/app';
  import { useProductStore } from '~~/common/stores/product';

  const Page = defineAsyncComponent(() => import('~~/shop/app/components/Page/Product/Page.vue'));

  defineOptions({
    name: 'Product',
  });

  const { $logger } = useNuxtApp();
  const route = useRoute();
  const productStore = useProductStore();

  // IMPORTANT: this fetch runs only if entered this URL: /shop/product/<product-id>
  await useAsyncData(
    `product_${route.params.id}`,
    async () => {
      try {
        const productId = String(route.params.id);
        await productStore.fetchMainProductForProductPage({
          loc: route.query?.loc,
          identifierType: 'id',
          id: productId,
        });
      } catch (err) {
        $logger.error(err);
      }
      return {};
    },
  );
</script>
